
import axios from 'axios'
import React, { useEffect, useState, Suspense } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { productsReceived, productsSetFilters, getFilteredProducts, getProductsFilters, loadGeoProducts, getProductsCategories, productsResetFilters, getAllFilteredProducts } from '../../store/slices/entities/products';
import { wrapper } from '../../store/configStore';
import { SERVER_IP } from '../../store/middleware/api';
import { loadEntityForce } from '../../store/slices/entities/crmActions';
import { NextSeo, ArticleJsonLd } from 'next-seo';
import { helper } from '../../utilities/helper';
import PicCont from '../../components/PicCont';
import Clickable from '../../components/Clickable';
import LinkWrap from '../../components/LinkWrap';
import Button from '../../components/Button';
import { mlogsItemReceived, mlogsReceived } from '../../store/slices/entities/mlogs';
import ClientReviews from '../../components/ClientReviews';
import HeroHeader from '../../components/HeroHeader';
import LandingCategories from '../../components/LandingCategories';
import lineToBr from '../../components/lineToBr';
import ProductList from '../../components/ProductList';
import BlogPart from '../../components/BlogPart';


export const getStaticProps = wrapper.getStaticProps(
    async ({ store, preview, params }) => {
      const { lastFetched } = store.getState().entities.mlogs
      let res
    
      if (!lastFetched || moment().diff(moment(lastFetched), 'minutes') > 10) {
        res = await axios.request(`${SERVER_IP}/mlog/url/${params.name_url}?msr=true`)
   
        store.dispatch({ type: mlogsItemReceived.type, payload: res.data })

      }
 
      return { props: { name_url: params.name_url, mlog: res.data } }
    }
  );
  
  export async function getStaticPaths() {
    console.log('GENERATING PATHS')
    const res = await axios.request(`${SERVER_IP}/mlog/paths`)
   
 
    let mlogs = res.data
  
    const paths = mlogs.map(em => ({ params: { name_url: em?.url} }))

    return {
      paths,
      fallback: true
    }
  }
  

const Mlog = ({name_url, mlog, }) => {

 
  return <div className='seasonalLanding mlog'>
         <NextSeo
         noindex={!mlog?.highlight}
            title={mlog?.seo_title}
            description={mlog?.seo_description}
            canonical={`https://miamisoundrental.com/av-central/${mlog?.url}`}
            twitter={{
                handle: '@miamisoundrent1',
                site: '@miamisoundrent1',
                cardType: 'summary_large_image',
            }}
            openGraph={{
                type: 'website',
                url: `https://miamisoundrental.com/av-central/${mlog?.url}`,
                title: mlog?.seo_title,
                description: mlog?.seo_description,
                images: [
                    {
                        url: `https://dnw-server.s3.us-east-2.amazonaws.com/${mlog?.body_image}`,
                        width: 800,
                        height: 600,
                        alt: 'Miami Sound Rental',
                    },

                ],
                site_name: 'Miami Sound Rental',
            }}
        />
            <ArticleJsonLd
      type="BlogPosting"
      url={`https://miamisoundrental.com/av-central/${mlog?.url}`}
      title={mlog?.h1_title}
      images={[
        `https://dnw-server.s3.us-east-2.amazonaws.com/${mlog?.header_image}`,
        `https://dnw-server.s3.us-east-2.amazonaws.com/${mlog?.body_image}`,
        `https://dnw-server.s3.us-east-2.amazonaws.com/${mlog?.vertical_image}`,
      ]}
      datePublished={mlog?.date}
      dateModified={mlog?.date}
      authorName={mlog?.createdBy?.fullName}
      description={mlog?.summary}
    />
            <HeroHeader picture_find={mlog?.header_image} 
                title={mlog?.h1_title}
                breadcrumbs={[['AV Central', '/av-central'], [helper.shortText(mlog?.h1_title, 3), `/av-central/${mlog?.url}`]]}
                
            >
                <p className={`thick subtitle`}>{lineToBr(mlog?.subtitle)} </p>
                <div className="mlogInfo">
              
                    <div className="createdBy">
                 
                        <PicCont picture={mlog?.created_by?.picture} />
                        <div className="col">
                             <span>Written By:</span>
                            <strong>{helper.fullName(mlog?.created_by)}</strong>
                        </div>
                    </div>
                    <span>Reading Time: {mlog?.reading_time}</span>
                    <span>Date Published: {new Date(mlog?.date).toDateString()}</span>
                </div>
            </HeroHeader>

     {mlog?.intro &&       <BlogPart className='partOne intro' body={mlog?.intro} />       }
            <BlogPart className='partOne' title={mlog?.part_one_title} body={mlog?.part_one_body} />     
         
         { mlog?.part_one_quote && <strong className='bold quote'>"{mlog?.part_one_quote}"</strong>}


            <div className='imageRow'>           
              
            { mlog?.part_six_body ? 
            
            <div className={` blogPart`} >
              <h2 className='upperBold'>{mlog?.part_two_title}</h2>
              <div className="body"  dangerouslySetInnerHTML={{__html:mlog?.part_two_body}}>

              </div>
              <h2 className='upperBold'>{mlog?.part_three_title}</h2>
              <div className="body"  dangerouslySetInnerHTML={{__html:mlog?.part_three_body}}>

              </div>

</div> :
  <BlogPart className='partTwo' title={mlog?.part_two_title} body={mlog?.part_two_body} />
}
    

                <PicCont width={600} height={800} picture={mlog?.vertical_image} />
             </div>   
          { mlog?.part_two_quote &&  <strong className='bold quote'>"{mlog?.part_two_quote}"</strong>}

              
                
       
          { mlog?.part_six_body  &&   <BlogPart className='partThree' title={mlog?.part_four_title} body={mlog?.part_four_body} />      }
          { mlog?.part_six_body  &&   <BlogPart className='partThree' title={mlog?.part_five_title} body={mlog?.part_five_body} />      }
          {mlog?.part_six_body &&       <div className='imageRow takeaway'>
              <PicCont width={800} height={600} picture={mlog?.body_image} />
              <BlogPart className='partTwo' title={mlog?.part_six_title} body={mlog?.part_six_body} />               
             </div>   }

     {!mlog?.part_six_body &&       <div className='imageRow takeaway'>
              <PicCont width={800} height={600} picture={mlog?.body_image} />
              <BlogPart className='partTwo' title={mlog?.part_three_title} body={mlog?.part_three_body} />               
             </div>   }
             {mlog?.part_three_quote &&  <strong className='bold quote'>"{mlog?.part_three_quote}"</strong>}

             <div className='scs'>
      <LandingCategories ui='v2' heading='Explore our AV Categories' />
    </div>

    <ClientReviews ui='v2' />

  </div>
}

export default Mlog
